import React, { Fragment } from 'react';
import Footer from "../component/layout/footer";
import Header from "../component/layout/header";
import PageHeader from "../component/layout/pageheader";

const PrivacyPolicy = () => {
    return (
        <Fragment>
            <Header />
            <PageHeader title={'Privacy Policy'} curPage={'Privacy Policy'} />
            <div className="privacy-section padding-tb section-bg">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-12">
                            <div className="privacy-policy-content" style={{ background: "#fff", padding: "40px", borderRadius: "12px", boxShadow: "0 4px 20px rgba(0,0,0,0.06)" }}>
                                <div className="text-center mb-4">
                                    <h2 style={{ color: "#102a43", fontWeight: "700", marginBottom: "10px" }}>Privacy Policy</h2>
                                    <h4 style={{ color: "#f58220", fontWeight: "600" }}>Hidaya International Schools</h4>
                                    <p className="text-muted" style={{ fontSize: "14px", fontStyle: "italic", marginTop: "5px" }}>
                                        Last Updated: August 21, 2026
                                    </p>
                                </div>
                                <hr style={{ margin: "25px 0 35px", borderColor: "#eee" }} />

                                <div className="policy-section mb-4">
                                    <h3 style={{ color: "#102a43", fontSize: "20px", fontWeight: "600", marginBottom: "12px" }}>
                                        1. Introduction
                                    </h3>
                                    <p style={{ lineHeight: "1.8", color: "#486581" }}>
                                        Welcome to the Hidaya International Schools portal and mobile application. We are committed to protecting the privacy of our students, parents, and staff. This policy describes how we collect, use, and safeguard the information managed within our school management system.
                                    </p>
                                </div>

                                <div className="policy-section mb-4">
                                    <h3 style={{ color: "#102a43", fontSize: "20px", fontWeight: "600", marginBottom: "12px" }}>
                                        2. Account Creation &amp; Data Collection
                                    </h3>
                                    <p style={{ lineHeight: "1.8", color: "#486581" }}>
                                        This platform is a closed system for the use of authorized Hidaya International Schools affiliates.
                                    </p>
                                    <ul style={{ paddingLeft: "20px", lineHeight: "1.8", color: "#486581" }}>
                                        <li className="mb-2">
                                            <strong>No Public Registration:</strong> There is no public signup or registration form.
                                        </li>
                                        <li className="mb-2">
                                            <strong>Administrative Provisioning:</strong> All user accounts (Student, Parent, and Staff) are created and managed by the Campus Administrator.
                                        </li>
                                        <li className="mb-2">
                                            <strong>Data Provided by the School:</strong> The information stored in the portal is provided by the campus at the time of admission or employment. This includes:
                                            <ul style={{ paddingLeft: "20px", marginTop: "8px" }}>
                                                <li>Student Data (Name, Date of Birth, Academics)</li>
                                                <li>Parent/Guardian Data (CNIC, Contact Information)</li>
                                                <li>Financial Data (Fee Structure, Vouchers)</li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>

                                <div className="policy-section mb-4">
                                    <h3 style={{ color: "#102a43", fontSize: "20px", fontWeight: "600", marginBottom: "12px" }}>
                                        3. Children’s Privacy (Users Under 13)
                                    </h3>
                                    <p style={{ lineHeight: "1.8", color: "#486581" }}>
                                        Given that our portal manages data for students under the age of 13, we adhere to strict protective measures:
                                    </p>
                                    <ul style={{ paddingLeft: "20px", lineHeight: "1.8", color: "#486581" }}>
                                        <li className="mb-2">
                                            <strong>School-Level Consent:</strong> Campus administration obtains parental consent during the physical admission process.
                                        </li>
                                        <li className="mb-2">
                                            <strong>Purpose-Driven:</strong> Only collect and display data reasonably necessary for academic functions.
                                        </li>
                                        <li className="mb-2">
                                            <strong>Parental Access:</strong> Parents can view and request data correction via their Campus Administrator.
                                        </li>
                                    </ul>
                                </div>

                                <div className="policy-section mb-4">
                                    <h3 style={{ color: "#102a43", fontSize: "20px", fontWeight: "600", marginBottom: "12px" }}>
                                        4. Use of Information
                                    </h3>
                                    <p style={{ lineHeight: "1.8", color: "#486581" }}>
                                        The data is used exclusively for the following school management purposes:
                                    </p>
                                    <ol style={{ paddingLeft: "20px", lineHeight: "1.8", color: "#486581" }}>
                                        <li className="mb-2">Generating and tracking Digital Fee Vouchers.</li>
                                        <li className="mb-2">Displaying student attendance and performance reports.</li>
                                        <li className="mb-2">Facilitating official communication and notifications.</li>
                                        <li className="mb-2">Maintaining secure administrative records.</li>
                                    </ol>
                                </div>

                                <div className="policy-section mb-4">
                                    <h3 style={{ color: "#102a43", fontSize: "20px", fontWeight: "600", marginBottom: "12px" }}>
                                        5. Data Sharing
                                    </h3>
                                    <ul style={{ paddingLeft: "20px", lineHeight: "1.8", color: "#486581" }}>
                                        <li className="mb-2">
                                            <strong>No Sale of Data:</strong> We do not sell, rent, or trade personal information.
                                        </li>
                                        <li className="mb-2">
                                            <strong>Service Providers:</strong> Secure cloud servers like AWS or Google Cloud are used solely for infrastructure.
                                        </li>
                                        <li className="mb-2">
                                            <strong>Legal Compliance:</strong> Disclosure only if required by Pakistani law or FBR for tax purposes.
                                        </li>
                                    </ul>
                                </div>

                                <div className="policy-section mb-4">
                                    <h3 style={{ color: "#102a43", fontSize: "20px", fontWeight: "600", marginBottom: "12px" }}>
                                        6. Security
                                    </h3>
                                    <p style={{ lineHeight: "1.8", color: "#486581" }}>
                                        We implement industry-standard security protocols, including SSL encryption and restricted database access, to ensure that student and financial records remain confidential and protected.
                                    </p>
                                </div>

                                <div className="policy-section mb-4">
                                    <h3 style={{ color: "#102a43", fontSize: "20px", fontWeight: "600", marginBottom: "12px" }}>
                                        7. Data Retention &amp; Deletion Process
                                    </h3>
                                    <p style={{ lineHeight: "1.8", color: "#486581" }}>
                                        We respect your right to control your personal data. Since accounts are administratively provisioned, users cannot delete their accounts directly from inside the application.
                                    </p>
                                    <ul style={{ paddingLeft: "20px", lineHeight: "1.8", color: "#486581" }}>
                                        <li className="mb-2">
                                            <strong>How to Request Deletion:</strong> Users (Staff, Parents, or Legal Guardians on behalf of students) can submit a data deletion request by contacting their respective Campus Administrator or by emailing us directly at <a href="mailto:info@hint.edu.pk" style={{ color: "#f58220" }}>info@hint.edu.pk</a>.
                                        </li>
                                        <li className="mb-2">
                                            <strong>Processing Time:</strong> Upon receiving a verified request, we will initiate the account deactivation and deletion process within 14 business days.
                                        </li>
                                        <li className="mb-2">
                                            <strong>Regulatory Retention:</strong> Please note that certain academic, attendance, and financial history records may be retained for a legally mandated period to comply with official educational regulations and auditing requirements in Pakistan.
                                        </li>
                                    </ul>
                                </div>

                                <div className="policy-section mb-2" style={{ background: "#f8f9fa", padding: "25px", borderRadius: "8px", borderLeft: "4px solid #f58220" }}>
                                    <h3 style={{ color: "#102a43", fontSize: "20px", fontWeight: "600", marginBottom: "12px" }}>
                                        8. Contact Us
                                    </h3>
                                    <p style={{ lineHeight: "1.8", color: "#486581", marginBottom: "10px" }}>
                                        For any queries regarding this Privacy Policy, data management, or to submit a data deletion request, please contact:
                                    </p>
                                    <div style={{ color: "#334e68", lineHeight: "1.8" }}>
                                        <strong>Hidaya International Schools Head Office</strong><br />
                                        📍 103 N Block Model Town Lahore, Pakistan<br />
                                        ✉️ Email: <a href="mailto:info@hint.edu.pk" style={{ color: "#f58220" }}>info@hint.edu.pk</a><br />
                                        🌐 Website: <a href="https://www.hint.edu.pk" target="_blank" rel="noreferrer" style={{ color: "#f58220" }}>www.hint.edu.pk</a><br />
                                        📞 Phone: +9233-HIDAYA-22
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </Fragment>
    );
};

export default PrivacyPolicy;
